module.exports = __webpack_public_path__ + "static/img/modal_logo_black.4a2463c8.svg";